<template>
    <div class="sus-container">
        <!-- title -->
        <h1 class="main-title">
            <span>
                {{$t('sustainability.title')}}
                <hr>
            </span>
        </h1>
        <!-- Sustainability content -->
        <div class="row sus-row">
            <div class="sus-list">
                <div class="col-sm-8">
                    <div class="show">
                        <img class="sus-img" style="margin-top:0;" src="../../assets/images/pexels-alena-koval-886521.png">
                    </div>
                    <p class="sus-text">
                        {{$t('sustainability.carbonFootprint')}}
                    </p>
                     <div class="show">
                        <img src="../../assets/images/pexels-sohail-na-807598.png" alt="">
                    </div>
                    <p class="sus-text">
                        {{$t('sustainability.pdaComponent')}}<br>
                    </p>
                    
                    <p class="sus-text">
                        {{$t('sustainability.frontrunner')}}
                    </p>
                </div>
                <div class="col-sm-4 first-img hide">
                    <img class="sus-img" src="../../assets/images/pexels-alena-koval-886521.png">
                </div>
                <div class="col-sm-4 hide">
                    <img src="../../assets/images/pexels-trace-hudson-2365457.png" alt="">
                </div>
                <div class="col-sm-4">
                    <img src="../../assets/images/pexels-daria-shevtsova-1680140.png" alt="">
                </div>
                <div class="col-sm-4 hide">
                    <img src="../../assets/images/pexels-sohail-na-807598.png" alt="">
                </div>
                <div class="col-sm-4 show">
                    <img src="../../assets/images/pexels-trace-hudson-2365457.png" alt="">
                </div>
                <!-- <li v-for="(item,index) in susData" :key="index">
                    <img :src="item.imgUrl" v-if="item.type == 'img'">
                </li> -->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // susData:[]
            }
        },
        mounted(){
            // this.getSusData();
        },
        methods:{
            // getSusData () {
            //     this.$api.sustainability.sustainabilityList().then(res=>{
            //         this.susData = res.data.result
            //         console.log(res.data.result)
            //     }).catch(
            //         (error) => {
            //             console.log(error)
            //         }
            //     )
            // }
        }
    }
</script>

<style scoped>
    .sus-list{
        overflow: hidden;
    }
    .sus-text,.sus-img{
        width:100%;
        text-align: left;
    }
    .sus-list .col-sm-4{
        padding:0 1rem;
        margin-top: 2rem;
        margin-bottom: 2rem;
        overflow: hidden;
    }
    .sus-list .first-img{
        margin-top: 0 !important;
    }
    .sus-list p{
        width: auto;
        text-align: left;
        font-size: 1.6rem;
        line-height: 2rem;
    }
    .sus-list img{
        max-width: 100%;
        height:auto;
    }
    .show{
        display: none !important;
    }
    .hide{
        display: block !important;
    }
    @media (min-width:768px) and (max-width:1024px){
        .sus-list .first-img{
            height: 40rem;
        }
    }
    @media (max-width: 767px){
        .sus-list .col-sm-8,.sus-list .col-sm-4{
            padding:0 2rem
        }
        .sus-list .col-sm-4{
            margin-top: 0;
        }
        .sus-list .col-sm-4:last-child{
            margin-bottom: 0;
        }
        .sus-list img{
            margin-top: 2rem;
            margin-bottom: 0;
        }
        .sus-list .col-sm-4:last-child img{
            margin-top: 0;
            margin-bottom: 0;
        }
        .sus-list p{
            font-size: 0.7rem;
            line-height: 1rem;
            padding:0;
            margin-top: 2rem;
        }
        .sus-list p:first-child{
            margin-top: 0;
        }
        .sus-text,.sus-img{
            height: auto;
        }
        .show{
            display: block !important;
        }
        .hide{
            display: none !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/Company/Sustainability.vue